import { render, staticRenderFns } from "./ListDevelopments.vue?vue&type=template&id=363b41ca"
import script from "./ListDevelopments.vue?vue&type=script&lang=js"
export * from "./ListDevelopments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports